import { useController } from 'react-hook-form'
import Radio from '@groovehq/internal-design-system/lib/components/Radio/Radio'
import { text } from '@groovehq/internal-design-system/lib/styles/elements'

const RefundTypeSelection = ({
  name,
  control,
  unpaid,
  refundAmountFormatted,
}) => {
  const {
    field: { onChange, value },
  } = useController({
    name,
    control,
  })
  if (unpaid) {
    return (
      <div>
        <Radio
          id="refund-now"
          name={name}
          value="refund-now"
          checked={value === 'refund-now'}
          onChange={onChange}
          onBlur={onChange}
        >
          Manual
        </Radio>
        <div css={text.styles.textMediumDark} className="grui pl-12">
          {`${refundAmountFormatted} was authorized`}
        </div>
      </div>
    )
  }
  return (
    <>
      <div className="grui mb-4">
        <Radio
          id="refund-now"
          name={name}
          value="refund-now"
          checked={value === 'refund-now'}
          onChange={onChange}
          onBlur={onChange}
        >
          {`Refund ${refundAmountFormatted}`}
        </Radio>
      </div>
      <Radio
        id="refund-later"
        name={name}
        value="refund-later"
        checked={value === 'refund-later'}
        onChange={onChange}
        onBlur={onChange}
      >
        Refund later
      </Radio>
      {value === 'refund-later' && (
        <div css={text.styles.textMediumDark} className="grui pl-12">
          Your customer won’t be refunded. Refund the amount owed at a later
          point.
        </div>
      )}
    </>
  )
}

export default RefundTypeSelection
